import { createSlice } from '@reduxjs/toolkit'
import { createActions } from "@helper"
import * as actions from '../action'

const initialState = {
    params: {
	    refundTypes: '', // 类型
	    refundStatus: '',
	    orderCode: '', // 订单编号
	    orderItemCode: '', // 子订单编号
	    buyer: '', // 买家账号
	    memberMobileNumbers: '', // 会员手机号
	    refundCodesStr: '', // 售后订单号
	    returnLogisticsNo: '', // 退货物流单号
	    orderTypeList: [], // 订单类型
	    exchangeState: '', // 换货状态
	    createDate: [], // 创建时间
	    refundDate: [] // 退款完成时间
    },
    page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
    },
    refundList: [] // 售后单列表
}

const reducers = createActions({
    setParams: (state, action) => {
        const { params, ...other } = state
        return { ...other, params: { ...params, ...action.payload } }
    },
    queryRefundListAction: {
        pending: (state, action) => {
            const { meta: { arg: { data } } } = action
	        const {
                pageNum,
		        pageSize,
		        orderCode,
		        buyer,
		        refundTypes,
		        refundStatus,
		        orderItemCode,
		        returnLogisticsNo,
		        memberMobileNumbers,
		        refundCodesStr,
		        createStartDate,
		        createEndDate,
		        refundStartDate,
		        refundEndDate,
		        ...otherParams
            } = data
	        
	        const createDate = createStartDate ? [createStartDate, createEndDate] : []
	        const refundDate = refundStartDate ? [refundStartDate, refundEndDate] : []
	        
	        return {
                ...state,
		        params: {
                    ...otherParams,
			        orderCode: orderCode.join(''),
			        buyer: buyer.join(''),
			        refundTypes: refundTypes.join(''),
			        refundStatus,
			        orderItemCode: orderItemCode.join(''),
			        returnLogisticsNo: returnLogisticsNo.join(''),
			        memberMobileNumbers: memberMobileNumbers.join(''),
			        refundCodesStr: refundCodesStr.join(''),
			        createDate,
			        refundDate
		        },
		        page: { ...state.page, pageNum, pageSize }
            }
        },
        success: (state, action) => {
	        const { total, list } = action.payload
	        const refundList = list.map(li => ({ ...li, key: li.refundCode }))
			
            return {
                ...state,
	            page: { ...state.page, total },
	            refundList
            }
        }
    }
}, actions)

const orderSlice = createSlice({
    name: 'orderRefund',
    initialState,
    ...reducers
})

export const getParams = state => state.orderRefund.params

export const getPages = state => state.orderRefund.page

export const getOrderList = state => state.orderRefund.refundList

export const { setParams } = orderSlice.actions

export default orderSlice
